import LocalizedStrings from 'react-localization';

const localizedTexts = new LocalizedStrings({
    "de": {
        "title": "Ranglisten",
        "titleDownloadOrganizationResultsPDF": "Vereinsresultate als PDF",
        "labelSelectDiscipline": "Disziplin auswählen:",
        "labelSelectProgram":"Stich auswählen:",
        "labelAllFields":"Alle Felder",
        "labelAllOrgs":"Alle Vereine",
        "labelDiscipline":"Disziplin",
        "labelProgram":"Stich",
        "labelField":"Feld",
        "labelSearch":"Suche",
        "labelOrganizations":"Verein",
        "labelDownloadPDF" : "PDF Herunterladen",
        "labelClose" : "Schliessen",
        "labelSingle":"Einzel",
        "labelGroup":"Einzel/Gruppe",
        "labelSection": "Sektionsrangliste",
        "headerRank":"Rang",
        "headerName":"Name",
        "headerWeapon":"Waffe",
        "headerAgeCat":"Alterskategorie",
        "headerAge":"Alter",
        "headerBirthyear":"Jahrgang",
        "headerResult":"Resultat",
        "headerCity":"Ort",
        "headerOrganisation":"Verein",
        "headerParticipantCount":"Anzahl Teilnehmer",
        "headerMinimumMandatoryParticipantCount":"Anzahl Mindestplichtresultate",
        "headerMandatoryParticipantCount":"Anzahl Plichtresultate",
        "headerOrganisationCategory":"Kategorie",
        "textAllFields":"Alle Felder",
        "textAllOrgs":"Alle Vereine",
        "textSelectOrganization":"Verein wählen",
        "errorGeneralText": "Fehler",
    },
    "fr": {
        "title": "Classements",
        "titleDownloadOrganizationResultsPDF": "Résultats du société en PDF",
        "labelSelectDiscipline": "Sélectionner la discipline:",
        "labelSelectProgram": "Sélectionner le programme:",
        "labelAllFields": "Tous les champs",
        "labelAllOrgs": "Toutes les associations",
        "labelDiscipline": "Discipline",
        "labelProgram": "Programme",
        "labelField": "Champ",
        "labelSearch": "Recherche",
        "labelOrganizations": "Association",
        "labelDownloadPDF" : "Télécharger PDF",
        "labelClose" : "Fermer",
        "headerRank": "Rang",
        "headerName": "Nom",
        "headerWeapon": "Arme",
        "headerAgeCat": "Catégorie d'âge",
        "headerAge": "Âge",
        "headerBirthyear": "Année de naissance",
        "headerResult": "Résultat",
        "headerCity": "Lieu",
        "headerOrganisation": "Association",
        "textAllFields": "Tous les champs",
        "textAllOrgs": "Toutes les associations",
        "textSelectOrganization":"Sélectionner société",
        "errorGeneralText": "Erreur",
    },
    "it": {
        "title": "Classifiche",
        "titleDownloadOrganizationResultsPDF": "Risultati della società in PDF",
        "labelSelectDiscipline": "Seleziona disciplina:",
        "labelSelectProgram": "Seleziona programma:",
        "labelAllFields": "Tutti i campi",
        "labelAllOrgs": "Tutte le associazioni",
        "labelDiscipline": "Disciplina",
        "labelProgram": "Programma",
        "labelField": "Campo",
        "labelSearch": "Cerca",
        "labelOrganizations": "Associazione",
        "labelDownloadPDF" : "Scarica PDF",
        "labelClose" : "Chiudi",
        "headerRank": "Rango",
        "headerName": "Nome",
        "headerWeapon": "Arma",
        "headerAgeCat": "Categoria d'età",
        "headerAge": "Età",
        "headerBirthyear": "Anno di nascita",
        "headerResult": "Risultato",
        "headerCity": "Luogo",
        "headerOrganisation": "Associazione",
        "textAllFields": "Tutti i campi",
        "textAllOrgs": "Tutte le associazioni",
        "textSelectOrganization":"Seleziona società",
        "errorGeneralText": "Errore",
    },
    "en": {
        "title": "Rankings",
        "titleDownloadOrganizationResultsPDF": "Organization results as PDF",
        "labelSelectDiscipline": "Select discipline:",
        "labelSelectProgram": "Select program:",
        "labelAllFields": "All fields",
        "labelAllOrgs": "All organizations",
        "labelDiscipline": "Discipline",
        "labelProgram": "Program",
        "labelField": "Field",
        "labelSearch": "Search",
        "labelOrganizations": "Organization",
        "labelDownloadPDF" : "Download PDF",
        "labelClose" : "Close",
        "headerRank": "Rank",
        "headerName": "Name",
        "headerWeapon": "Weapon",
        "headerAgeCat": "Age category",
        "headerAge": "Age",
        "headerBirthyear": "Year of birth",
        "headerResult": "Result",
        "headerCity": "Location",
        "headerOrganisation": "Organization",
        "textAllFields": "All fields",
        "textAllOrgs": "All organizations",
        "textSelectOrganization":"Select organization",
        "errorGeneralText": "Error",
    }
});

export default localizedTexts;